import { NavLink as NavLinkBase } from 'react-router-dom'
import styled from 'styled-components'
// types & utils
import type { LinkProps } from 'react-router-dom'

const NavLink = ({ children, to, ...props }: LinkProps) => {
  return (
    <Wrapper>
      <NavLinkBase to={to} {...props}>
        {children}
      </NavLinkBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin: 0 1rem;
`

export { NavLink }
